module.exports = __webpack_public_path__ + "static/img/ent-8.1dfaaa8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-8.jpg
// module id = mgr3
// module chunks = 52